import React from 'react'
import * as Constant from '../Constants';


export const DohImage = ({type, size}) => {
  const sizes = {
    small: 23,
    medium: 30,
    large: 50
  }

  const images = {
    'General Use': Constant.GENERAL_DOH_IMG,
    'High CBD': Constant.CBD_DOH_IMG,
    'High THC': Constant.THC_DOH_IMG,
  }

  return(
    <img
      style={{width: sizes[size] || 30}}
      src={images[type] || Constant.GENERAL_DOH_IMG}
      alt={type}
      className={size === 'large' && 'sdp_category_icon'}
    />
  )
}
